/* eslint-disable quote-props */
export default {
  en: {
    Common: {
      '制空権シミュレータ': 'Aerial Combat Simulator',
      'サイト設定': 'Site settings',
      'マスターデータ読込中': 'Now Loading',
      'OK': 'OK',
      '実行': 'OK',
      '戻る': 'Cancel',
      'キャンセル': 'Cancel',
      'リセット': 'Reset',
      '出力': 'Output',
      '作成': 'Create',
      '更新': 'Update',
      '適用': 'Apply',
      '展開': 'Expand',
      '閉じる': 'Close',
      '初期値': 'Reset',
      '最大値': 'Max',
      '既定値': 'Default',
      '削除': 'Delete',
      '編集': 'Edit',
      '保存': 'Save',
      '別名保存': 'Save As',
      '共有': 'Share',
      '編成共有': 'Share',
      '元に戻す': 'Undo',
      'やり直す': 'Redo',
      '編成アップロード': 'Upload',
      'コピーされました。': 'Copied.',
      'コードをコピー': 'Copy',
      '取込': 'Import',
      '検索': 'Search',
      '件': ' hits',
      'さらに読み込む': 'Read more',
      '制空値': 'Fighter Power',
      '制空': 'FP',
      '基地制空': 'LBAS FP',
      '敵制空値': 'Enemy FP',
      '防空制空': 'Def FP',
      'x機': '{number} slots',
      '装備名称': 'Name',
      '艦娘名': 'Name',
      '装備名': 'Name',
      '敵艦名': 'Name',
      '図鑑ID': 'No.',
      '耐久': 'HP',
      '火力': 'FP',
      '砲戦火力': 'FP (Day)',
      '夜戦火力': 'FP (Night)',
      '支援火力': 'Support FP',
      '雷撃火力': 'Torpedo FP',
      '雷装': 'Torp',
      '爆装': 'Bombing',
      '装甲': 'Armor',
      '対空': 'AA',
      '出撃対空': 'AA',
      '防空対空': 'Def AA',
      '索敵': 'LoS',
      '回避': 'Eva',
      '命中': 'Acc',
      '支援命中': 'Support Acc',
      '対潜': 'ASW',
      '対爆': 'Anti-Bombers',
      '迎撃': 'Interception',
      '射程': 'Range',
      '搭載数': 'Plane Slot Size',
      '極長+': '',
      '極長': '',
      '極+': 'Longest+',
      '極': 'Longest',
      '超長+': 'VL+',
      '超長': 'VL',
      '長': 'L',
      '中': 'M',
      '短': 'S',
      '半径': 'Radius',
      'tp': 'TP',
      'TP': 'TP',
      'コスト': 'Cost',
      '配置コスト': 'Cost',
      '射撃回避': 'AA Resist',
      '回避性能': {
        '超': 'High+',
        '強': 'High',
        '中': 'Avg',
        '弱': 'Low',
        '任意': 'Manual',
        'なし': 'None',
        '': '',
      },
      '装甲減少': 'Armor Debuff',
      '命中項': 'Acc Term',
      '回避項': 'Eva Term',
      'CI項': 'Cut-In Term',
      '熟練度': 'Proficiency',
      '改修': 'Improvement',
      '改修値': 'Improvement',
      '加重対空': 'Ship AA',
      '艦隊防空': 'Fleet AA',
      '艦隊防空値': 'Fleet AA',
      'Lv': 'Lv',
      '改造Lv': 'Remodel Lv',
      '運': 'Luck',
      '速力': 'Speed',
      '総搭載数': 'Slot',
      '装備命中': 'Accuracy',
      '確保': 'AS+',
      '優勢': 'AS',
      '拮抗': 'AP',
      '劣勢': 'AD',
      '喪失': 'AI',
      '不発': '-',
      '制空権確保': 'Air Supremacy',
      '航空優勢': 'Air Superiority',
      '航空拮抗': 'Air Parity',
      '航空劣勢': 'Air Denial',
      '制空権喪失': 'Air Incapability',
      '陣形': 'Formation',
      '単縦陣': 'Line Ahead',
      '複縦陣': 'Double Line',
      '輪形陣': 'Diamond',
      '梯形陣': 'Echelon',
      '単横陣': 'Line Abreast',
      '警戒陣': 'Vanguard',
      '第一警戒': 'Cruising Formation 1',
      '第二警戒': 'Cruising Formation 2',
      '第三警戒': 'Cruising Formation 3',
      '第四警戒': 'Cruising Formation 4',
      '通常': 'Battle',
      '連合': 'Combined',
      '空襲': 'Air Raid',
      '夜戦': 'Night Battle',
      '重爆': 'High Altitude Air-Raid',
      '航空戦': 'Air Battle',
      '超重爆': 'Superfortress Air-Raid Sequence',
      '対潜空襲': 'Air Supported Asw',
      '支援': 'Support',
      '合計': 'Total',
      '平均': 'Avg.',
      '順序入替': 'Reordering',
      '入替完了': 'Done',
      '一括変更': 'Batch operation',
      '一括設定': 'Batch operation',
      'スクリーンショットを保存': 'Save screenshot',
      '最小化': 'Minimize',
      '探したけど見つからなかったよ': 'No matching data found',
      'もしかして': 'Please check your',
      '検索条件': ' search criteria',
      '既に配備されています。': 'Already deployed.',
      '配備を押せば無視して配備できます。': 'If you press Deploy, you can ignore it and deploy.',
      '配備': 'Deploy',
      '比較': 'Compare',
      '適用対象': 'Target',
      '選択されている航空隊に対し、下記の設定を適用します。': 'The following settings are applied to all equipment in the selected LBAS.',
      '選択されている艦隊の全艦娘に対し、下記の設定を適用します。': 'The following settings are applied to all ships in the selected fleet.',
      '戦闘機のみ最大': 'Maximize fighters only',
      '艦載機搭載数': 'Slot',
      '本当に削除しますか？': 'Are you sure you want to delete it?',
      '装備特効表示': 'Equipment Bonuses',
      'なし': 'None',
      '鎮守府秋刀魚祭り': 'Saury Festival',
      'ソート': 'Order',
      '読み': 'Alphabetical',
      '昇順': 'Ascending',
      '降順': 'Descending',
      '燃料': 'Fuel',
      '弾薬': 'Ammo',
      '燃料+弾薬': 'Fuel+Ammo',
      '運改修': 'Luck Improvement',
      '遠征': 'Expedition',
      '艦隊に艦載機が含まれています。遠征における艦載機の性能に対する補正の計算式が不明なため、遠征のステータス調整に利用する際は十分注意してください。': 'The fleet includes aircraft. The formula for the correction to the status of aircraft in an expedition is unknown, so please use caution when adjusting the status of an expedition.',
      '遠征ステータスチェッカー': 'Expedition Checker',
      '旗艦Lv': 'Flagship Lv',
      '合計Lv': 'Total Lv',
      '絞り込み': 'Filter',
      'その他': 'Others',
      '最終更新日時': 'Last Modified',
      '外部データ': 'Imported Data',
      '表示ステータス': 'Spec',
      '基本装備性能': 'Spec',
      '改修ボーナス': 'Improvement Bonuses',
      '実性能': 'Actual Spec',
      '航空隊ステータス': 'Air Squadron Spec',
    },
    Statuses: {
      'actualFire': 'FP',
      'dayBattleFirePower': 'FP(Day)',
      'actualTorpedo': 'Torp',
      'nightBattleFirePower': 'FP(Night)',
      'actualBomber': 'Bombing',
      'antiAir': 'AA',
      'actualAntiAir': 'AA',
      'actualDefenseAntiAir': 'Def AA',
      'actualArmor': 'Armor',
      'actualAsw': 'ASW',
      'actualAvoid': 'Eva',
      'actualScout': 'LoS',
      'actualAccuracy': 'Acc',
      'antiBomber': 'Anti-Bombers',
      'antiAirWeight': 'Ship AA',
      'antiAirBonus': 'Fleet AA',
      'radius': 'Radius',
      'cost': 'Cost',
      'tp': 'TP',
      'avoidId': 'AA Resist',
      'actualRange': 'Range',
    },
    Difficulty: {
      '難易度': 'Difficulty',
      '甲': 'Hard',
      '乙': 'Medium',
      '丙': 'Easy',
      '丁': 'Casual',
    },
    Setting: {
      '言語': 'Language',
      '艦娘や装備名は翻訳しない': 'Do not translate ship and equipment names',
      'サイトカラーテーマ': 'Site color theme',
      '通常': 'normal',
      '空色': 'sky',
      '桜色': 'pink',
      '翠色': 'green',
      '暗色': 'dark',
      '深海': 'deep sea',
      '装備表示UI調整': 'Equipment display UI adjustment',
      '枠線': 'border',
      '太枠': 'bold',
      '角丸': 'circle',
      'sample': 'sample',
      '未保存の編成タブを閉じる際の挙動': 'Settings for closing unsaved saved data tab',
      '確認ダイアログを表示する': 'Display confirmation dialog',
      '編成データのオートセーブ': 'Auto-save Setting',
      'オートセーブを有効にする': 'Enable Auto-save',
      '画像保存形式': 'Format for downloading images',
      'マウスホバー時の詳細情報表示': 'Information displayed on mouse hover',
      '無効(装備)': 'Disabled (Equipment)',
      '無効(艦娘)': 'Disabled (Ship)',
      '表示までのディレイ': 'Delay to display',
      '制空計算時のシミュレーション回数': 'Number of simulations',
      '数値が大きいほど計算の精度が上がりますが、': 'Larger values increase the accuracy of the calculation, but decrease performance during the calculation.',
      '計算時のパフォーマンスが低下します。': '',
      '回': 'times',
      '装備選択時のデフォルト熟練度': 'Default proficiency when selecting equipment',
      '一括設定': 'batch setting',
      'デッキビルダー形式データ読込設定': 'Deck Builder format data loading settings',
      '全滅率インジケーター表示': 'Show Annihilation Indicator',
      '図形で区別': 'Use a different shape',
      '常に全艦隊データを読み込む': 'Always load all fleet data',
      '編成データのバックアップ': 'Backup of saved data',
      '復元': 'restore',
      '保存した編成データのバックアップファイルを作成します': 'Create a backup file of saved data',
      '復元するバックアップファイルを選択': 'Select the backup file',
      '復元するデータ選択': 'Select the backup data',
      '編成データ': 'Saved files and folders',
      '在籍艦娘データ': 'Ship Data',
      '所持装備データ': 'Equipment Data',
      '艦隊URL出力履歴': 'URL Output History',
      '装備変更時の比較画面の表示': 'Display of comparison dialog when changing equipment',
    },
    Home: {
      '制空権シミュレータ': 'Simulator',
      'デッキビルダー形式データ': 'Deck Builder format',
      'URL情報より復元された艦娘在籍情報、装備所持情報が適用されています。': 'The data on ships and equipment restored by the URL data is applied.',
      '自分の登録情報に戻す場合は次のボタンを押下してください。': 'To quit, press the next button.',
      '終了': 'Quit',
      '作成した日': 'Ship and Equipment data you are currently viewing was created on {date}.',
      'メインメニュー': 'Main Menu',
      '本サイトの主要機能です。': 'Primary features.',
      '基地航空隊や艦隊、敵艦隊を編成することで、道中を含めた全ての戦闘の制空状態や艦載機の損耗、全滅率などのシミュレーションが可能です。': 'By organizing LBAS, fleets, and enemy fleets, it is possible to simulate the air status, aircraft losses, and shot down rate for all battles, including those on the road.',
      '艦娘 / 装備管理': 'Ship / Equipment',
      'サブの機能です。': 'Sub features.',
      '自分のゲーム内の艦娘、装備情報を登録すると、シミュレータ内で選択できる艦娘や装備に反映され、あの装備持ってた…？と悩む心配がなくなります。': 'When you register your in-game ship and equipment data, it will be reflected in the ship and equipment you can select in the simulator, so you don\'t have to worry about "I have that equipment...? anymore.',
      'みんなの編成': 'Someone Data',
      '他の人がアップロードした編成データを閲覧できます。': 'You can browse save data uploaded by others.',
      'おまけ': 'Extra',
      'おまけのページです': 'Extra Page',
      'データ引き継ぎ': 'Data Transfer',
      '本サイトで作成した編成データなどを他の端末やブラウザに引き継げます': 'Saved data created on this site can be restored on other browsers or devices.',
      'バックアップファイルを作成する': 'Create backup file',
      '作成されたバックアップファイルを、引き継ぎ先のPCや端末に移動させる': 'Move the created backup file to the PC or device you want to restore.',
      '引き継ぎ先で制空権シミュレータv2を開き、サイト設定を開く': 'Then access the "制空権シミュレータv2" on those devices and open the "Site setting".',
      '手順2で移動させてきたバックアップファイルを選択すれば引き継ぎは完了です': 'Select the backup file you have moved in step 2, and the restore is complete.',
      '旧制空権シミュレータ': '旧制空権シミュレータ',
      'で作成していた編成データや、登録されていた装備、艦娘情報を引き継ぎます。': 'The save data, equipment, and ships data that have been created and registered up to this point will be transferred.',
      'データ引継ぎ(編成)': 'Transfer(save data)',
      'データ引継ぎ(装備/艦娘)': 'Transfer(equipment / ship)',
      '引き継ぎ対象のデータを格納するフォルダーを作成します。': 'Create a folder to store the transferred data.',
      'フォルダー名を指定し、実行を押すと引き継ぎを開始します。': 'Specify a folder name and press OK to start the transfer.',
      '既に本サイトで装備 / 艦娘情報が登録されているようです。': 'Equipment / ship data is already registered on this site.',
      '引き継ぎを行うとこれらのデータは上書きされます。': 'These data will be overwritten when the transfer is performed. ',
      '本当に引き継ぎを行いますか？': 'Are you sure you want to do the transfer?',
      'サイト連携': 'Site Linkage',
      'デッキビルダー形式をURLに ?predeck=で埋め込めば編成を読み込めます。': 'You can load the deck builder format by embedding it in the URL with ?predeck=... in the URL to load the fleets data.',
      'URLが長すぎて上記の方法でエラーが出る場合は、URL fragmentsを利用した受け渡しも可能です。': 'If the URL is too long and an error occurs using the above method, it is possible to pass data using URL fragments.',
      'また、URL fragmentsを利用した形式では艦隊分析コード(艦娘、装備)形式の読み込みも同時に行うことができます。': 'The URL fragments format can also be used to perform kancolle-analysis code (Ship List, Equipment) format reading.',
      'ご支援': 'Support',
      '本サイトは無料ですが、それでもご支援いただけるという方向けに支援の手段を用意しました。': 'This site is free, but I have provided a way to make a donation.',
      'いつも本当にありがとうございます。': 'Thank you so much for your support.',
      '匿名でも利用可能な投げ銭サービスです。': 'This is a throw-away service that can be used anonymously.',
      'Amazon ほしい物リスト': 'Amazon Wish List',
      '物資やギフト券といった形であればこちら。': 'Here you can support in the form of supplies or gift certificates.',
      '著作権法第32条に基づき画像を引用し、著作権は権利者様へ帰属します。権利者様側からの画像等の削除の依頼や警告には速やかに対処いたします。': '',
      'また、本サイトの情報、計算結果によって受けた利益・損害その他あらゆる事象については一切の責任を負いません。': 'I am not responsible for any profits, damages or any other events resulting from the information or calculations on this site.',
      '編成データ名': 'Title',
      '補足情報': 'Description',
      '更新しました。': 'Updated.',
      '艦隊選択': 'Select Fleet',
      '常に全艦隊取り込む': 'Always import all fleet data',
      '取り込む艦隊を選択し、取り込みボタンを押してください。': 'Select the Fleet to be imported, then press the Import button.',
      'チェックすると、次回以降、常に全ての艦隊を取り込むようになります。': 'If checked, all fleets will always be imported next time.',
      'この設定は、設定からいつでも変更できます。': 'This setting can be changed at any time from the site settings.',
      '本ブラウザではデータ保存機能が利用できません。': 'The data saving function is not available in your browser.',
      'お使いのブラウザはIndexedDB非対応のようです。': 'It appears that your browser does not support IndexedDB.',
      '編成、設定、艦娘/装備を含む全データは本サイトを閉じた時点で削除されます。': "All data, including organization, settings, ship's daughter, and equipment data, will be deleted when this site is closed.",
      '別のブラウザのご利用をお勧めします。': 'I recommend using a different browser.',
      '旧編成データが見つかりませんでした。': 'Old data not found.',
      '所持装備 / 艦娘データが見つかりませんでした。': 'Equipment / ship data not found.',
      'データを読み込みましたが、引き継ぎ可能な編成データがありませんでした。': 'There was no transferable save data.',
      '所持装備 / 艦娘データの引き継ぎが完了しました。': 'Data transfer has been completed.',
      '編成データの引き継ぎが完了しました。': 'Data transfer has been completed.',
      'データ引継ぎに失敗しました。': 'Data transfer failed.',
      '新しいフォルダーを作成しました。': 'Completed.',
      '新しい編成を作成しました。': 'Completed.',
      '削除が完了しました。': 'Completed.',
      '編成の読み込みが完了しました。': 'Loading completed.',
      'デッキビルダー形式編成データを読み込みました。': 'Loaded deck builder format fleet data.',
      '在籍艦娘データの更新が完了しました。': 'The data update of the ship data has been completed.',
      '所持装備データの更新が完了しました。': 'The data update of the equipment data has been completed.',
      'データの読み込みに失敗しました。正しいデータではない可能性があります。': 'Loading failed.',
      '保存しました。': 'Saved.',
      '保存に失敗しました。': 'Save failed.',
      '所持情報の読み取りに失敗しました。': 'Loading failed.',
      '閲覧モードを終了しました。': 'Quit.',
      '読み込み失敗 -バックアップデータが壊れてるか、なんか違うファイルです。': 'Loading failed.',
      'バックアップデータを復元しました。': 'Restored.',
      '入力欄を入れ替えました。': 'Reordering completed.',
      '100 ～ 100000で指定してください。': 'Specify between 100 and 100,000.',
      '編成名 / 補足情報': 'Save data Title / Description',
      'トップ画面へ戻る': 'Return to Site Top',
      '艦娘、装備情報が登録されていません。': 'No ship and equipment data are registered.',
      '共有URLを生成しました。': 'Generated.',
      '共有URLの生成に失敗しました。': 'Generate failed.',
      '出力履歴を削除しました。': 'Deleted.',
      '計算が完了しました。': 'Calculation completed. (+100,000 times)',
      'ドラッグ & ドロップで入力欄を好きな順に並べ替え、入替完了を押してください。': 'Drag and drop to rearrange the input fields in the desired order, and then press "Done".',
      'アップロードが完了しました。': 'Uploaded.',
      'アップロードに失敗しました。': 'Upload failed.',
      '翻訳がまだ不完全な状態です。よろしければ助けていただけると幸いです。': 'Translation is still incomplete. If you would like to help me, I would appreciate it.',
      'お題箱': 'Request Box',
      'コピーされました。': 'Copied.',
      '更新が完了しました。': 'Update completed.',
      '編成を展開しました。': 'Deployed.',
      'URL fragmentsよりデータを読み込みました。': 'Data was read from URL fragments.',
      '更新履歴': 'Change Log',
      '雑です。': 'Very rough.',
    },
    SaveData: {
      '新しい編成を作成': 'New File',
      '新しいフォルダーを作成': 'New Folder',
      'フォルダーを全て開く': 'Expand Folders',
      'フォルダーを全て閉じる': 'Collapse Folders',
      'サイドバー固定': 'Fix sidebar',
      'サイドバー固定解除': 'Release sidebar fixation',
      '複製して開く': 'Duplicate and open',
      '情報を変更': 'Edit information',
      '名前順でソート': 'Sort by name',
      'このフォルダー内の全データ、フォルダーを名前順にソートします。': 'Sort all data and folders in this folder by name.',
      '本当にこのフォルダーを削除しますか？': 'Are you sure you want to delete this folder?',
      '外部データを全て削除します。よろしいですか？': 'Are you sure you want to delete all external data?',
      '本当にこのデータを削除しますか？': 'Are you sure you want to delete this file?',
      'フォルダー内の全データ、フォルダーが削除されます。': 'All files and folders in the folder will be deleted.',
      'フォルダー名': 'Title',
      '編成データ名': 'Title',
      '補足情報': 'Description',
      '保存されたデータ': 'Root',
      '共有URLを生成': 'Create shared link URL',
      'Twitterで共有': 'Share on Twitter',
      '作戦室で開く': 'Open in the FleetHub(作戦室)',
      '羅針盤シミュで開く': 'Open in the Compass Sim.',
      'デッキビルダーで開く': 'Open in the DeckBuilder(デッキビルダー)',
      'URLの発行に失敗しました。': 'Failed to create shared link URL.',
      '未保存の変更内容がありますが、このまま編成タブを閉じますか？': 'There are unsaved changes, do you want to close the tab?',
      '戻って保存するには、サイト上部の保存ボタンを押してください。': 'To go back and save, press the Save button at the top of the site.',
      '変更内容を破棄してタブを閉じる場合は、このままOKボタンを押してください。': 'To discard the changes and close the tab, press the OK button.',
      '次回以降表示しない': 'Do not show next time',
      '新規データ': 'New File',
      '新しいフォルダー': 'New Folder',
      '引き継ぎデータ': 'Imported Data',
      '投稿者': 'Poster',
      '『トップページ > みんなの編成』ページにて公開される編成をアップロードできます。': 'You can upload your saved data to be published on the "Top Page > Someone Data" page.',
      '編成のアップロードを行います。よろしいですか？': 'Upload the saved data. Are you sure?',
      '海域、難易度の指定が正しいか、アップロード前に今一度確認してください。': 'Please check once again before uploading to ensure that the world and difficulty level are specified correctly.',
      '原則、アップロードした編成をあとから編集・削除することはできません。': 'In principle, uploaded data cannot be edited or deleted later.',
      'どうしても削除したい場合、編成名や投稿者、出撃海域、更新日時や編成の特徴など、削除対象が特定できる情報を添えてご連絡ください。': 'If you must delete a message, please contact us with information that identifies the subject of the deletion, such as the title name, poster, world, update date and time, and organization characteristics.',
    },
    Airbase: {
      '基地航空隊': 'Land-Based Air Squadron',
      '全航空隊': 'All',
      '第x基地航空隊': 'LBAS #{number}',
      '第x航空隊': 'LBAS #{number}',
      '防空計算モード': 'Air Defense Mode',
      '基地派遣先設定': 'Select targeted node',
      '出撃': 'Sortie',
      '防空': 'Defense',
      '待機': 'Standby',
      '防空時制空値': 'Defense FP',
      '対重爆制空値': 'High Altitude Air-Raid FP',
      '対超重爆制空値': 'Airpower modifier against high altitude raids FP',
      '対重爆補正': 'Airpower modifier against high altitude raids',
      '対超重爆補正': 'Multiplier Bonus',
      '補正A': 'Multiplier A',
      '補正B': 'Multiplier B',
      '補正C': 'Multiplier C',
      '補正D1': 'Multiplier D',
      '補正D2': 'Flat D',
      '{target}基地航空隊の半径が不足している可能性があります。': 'The radius value of LBAS is not enough and the target node may not be reached. Please check {target}.',
      '{target}基地航空隊の半径が不足しています。': 'The radius value of LBAS is not enough to reach the target node. Please check {target}.',
      '第x波': 'Wave {number}',
      '搭載数を最大に戻す': 'Restore the number of slots',
      '基地空襲被害を発生させる': 'Generate air raid damage to the base',
      '第1スロットから順に搭載数を4機減らします。': 'Decrease the number of slots by 4, starting with the first slot.',
      '全基地航空隊リセット': 'Reset All LBAS',
      '基地航空隊派遣先設定': 'Select targeted node',
      '基地航空隊詳細': 'Details',
      '基地空襲が発生します。基地空襲による被害を考慮してください。': 'The enemy will raid the bases during the sortie. Shooting down due to this should be taken into account.',
      '基地クリップボード': 'Airbase Clipboard',
      '艦隊全体クリップボード': 'All Airbase Clipboard',
      '基地全てクリップボードへ追加': 'Add all LBAS to clipboard',
    },
    Fleet: {
      '自艦隊': 'Fleet',
      '全艦隊': 'All',
      '12隻表示': 'Display 12 ships',
      '第x艦隊': 'Fleet #{number}',
      '艦隊追加': 'Add Fleet',
      '艦隊削除': 'Remove Fleet',
      '第x艦隊以降のデータは本サイト内でのみ有効で、外部サイトへの出力の対象になりません。': 'The data in this fleet(Fleet #{number}) is valid only within this site and cannot be exported to external sites.',
      '画像出力': 'Image',
      '司令部Lv': 'HQ Level',
      '連合艦隊': 'Combined Fleet',
      '主力艦隊': 'Main Fleet',
      '随伴艦隊': 'Escort Fleet',
      '艦隊形式': 'Fleet Type',
      '通常艦隊': 'Single',
      '空母機動部隊': 'Carrier Task Force',
      '水上打撃部隊': 'Surface Task Force',
      '輸送護衛部隊': 'Transport Escort Force',
      '艦娘選択': 'Select Ship',
      '未装備': 'Empty',
      '補強増設未開放': 'Not released',
      '艦娘': 'Ship',
      '装備': 'Equipment',
      '装備ボーナス': 'Equipment Bonus',
      '触接': 'Contact',
      '夜偵': 'Night Contact',
      '艦隊詳細': 'Details',
      '艦隊情報': 'Information',
      '艦隊ステータス': 'Fleet Status',
      '対空砲火': 'Fleet Anti-Air Defense',
      '夜間航空攻撃': 'Carrier Night Attack',
      '航空戦火力': 'Airstrike Damage',
      '対潜支援火力': 'ASW Support Damage',
      '航空支援火力': 'Airstrike Support Damage',
      '撃墜': 'Prop,Fixed',
      '噴進': 'AARB',
      '先制対潜': 'OASW',
      '対潜先制爆雷攻撃': 'Opening ASW',
      '可': '',
      '不可': '',
      '不足対潜値': 'Missing Asw Value',
      '必要艦娘Lv': 'Required Ship Level',
      'x列': '{number} col',
      '特殊攻撃': 'Special Attack',
      '一撃大破': 'chance of being heavily damage',
      '一撃中破': 'chance of being moderately damage',
      '主主CI': 'Main AP Shell CI',
      '連撃': 'Double Attack',
      '主徹CI': 'Sec AP Shell CI',
      '主電CI': 'Radar CI',
      '主副CI': 'Sec CI',
      'FBA': 'FBA',
      'BBA': 'BBA',
      'BA': 'BA',
      '夜間特殊攻撃': 'Night Special Attack',
      '通常': 'Normal',
      '主主主CI': 'MGx3 CI',
      '主主副CI': 'MGx2+SG CI',
      '魚雷CI': 'Torpx2 CI',
      '砲雷CI': 'MG+Torp CI',
      '主魚電CI': 'MG+Torp+Radar CI',
      '魚見電CI': 'Torp+Loolout+Radar CI',
      '魚水魚CI': 'Torpx2+Lookout CI',
      '魚ド水CI': 'Torp+Drum+Lookout CI',
      '潜電魚CI': 'SS CI(Torp+Radar)',
      '潜魚雷CI': 'SS CI(Torp)',
      '夜襲CIA': 'CV CI (x1.25)',
      '夜襲CIB': 'CV CI (x1.20)',
      '光電管彗星CI': 'Suisei CI',
      '夜爆CI': 'Bomber CI',
      '夜襲CIC': 'CV CI (x1.18)',
      '合計': 'Total',
      '搭載数': 'Slots',
      '最終戦闘までの撃墜数に応じて、搭載数を自動設定します。': 'Automatically sets the number of slots according the number of shots down until the final battle.',
      '満タン': 'Full',
      '最小': 'Worst',
      '平均': 'Average',
      '最大': 'Best',
      '戦闘機スロットを最適化': 'Optimize fighter slot',
      '全艦隊リセット': 'Reset All Fleet',
      '艦隊リセット': 'Reset Fleet',
      '艦娘入力欄を増やす': 'Add Ship',
      '艦娘入力欄を減らす': 'Remove Ship',
      'ステータス': 'Status',
      '改造状態': 'Remodeling',
      '未改造': 'Initial',
      '中間改造': 'Intermediate',
      '最終改造': 'Final',
      '装備搭載可否': 'Equipability',
      '戦闘機': 'Fighter',
      '甲標的': 'Midget Submarine',
      '大型探照灯': 'Large Searchlight',
      '護衛空母': 'Escort Carrier',
      '装備スロット数': 'Number of slots',
      '2スロ以上': '2 or more',
      '3スロ以上': '3 or more',
      '4スロ以上': '4 or more',
      '5スロ以上': '5 or more',
      '最速': 'Fastest',
      '高速+': 'Fast+',
      '高速': 'Fast',
      '低速': 'Slow',
      '低速統一': 'Slow Only',
      '艦隊': ' Fleet',
      '札あり': 'Tag applied',
      '補強増設': 'Ex Slot',
      '開放': 'Release',
      '13号電探系': 'Type 13 Radar',
      '22号電探系': 'Type 22 Radar',
      '電探マスト': 'Type 13 + 22 Radar M',
      'その他電探': 'Other Radars',
      '在籍艦娘反映': 'Reflect ship data',
      '自動先制対潜': 'Auto OASW',
      'お気に入り': 'Favorites Only',
      'お気に入り編集': 'Edit Favorites',
      'ケッコン艦': 'Marriage',
      '全解除': 'Reset all favorite ship',
      '搭載': 'Slot ',
      'コンバート改造': 'Convert',
      '艦娘クリップボード': 'Ship Clipboard',
      '艦隊クリップボード': 'Fleet Clipboard',
      '装備プリセット展開': 'Show Equipment Preset dialog',
      '現在の艦隊': 'Current Fleet',
      'デッキビルダー読込': 'Import Deck Builder',
      '艦隊クリップボードにデッキビルダー形式の艦隊データを直接追加することができます。': 'Loading Deck Builder format data on this screen will add the fleet data to the Fleet Clipboard.',
      '計算対象から省く': 'Exclude from calculation',
      '装備一括解除': 'Clear Equipments',
      '対空CI': 'AA Cut-In',
      '攻撃機搭載数': 'Attacker Plane Slot',
      '対空射撃回避': 'AA Resistance',
      '加重対空補正': 'Ship AA Modifier',
      '艦隊防空補正': 'Fleet AA Modifier',
      '割合撃墜': 'Prop',
      '固定撃墜': 'Fixed',
      '最低保証': 'Guaranteed',
      '両成功': 'Both',
      '空襲マス': 'Air Raid Node',
      '敵側式': 'Abyssal Formula',
      'クリップボード': 'Clipboard',
      'クリックで展開': 'Click to expand',
      'クリップボードへ追加': 'Add to Clipboard',
      '艦隊に艦娘が設定されていません。': 'No Ships',
      '索敵値が不足している可能性があります。': 'Line of Sight (LoS) value may be insufficient. Require LoS: {LoS}, Cn: {num}',
      '航空偵察': 'Air Reconnaissance Score: {score}, Required: {required}, Great Success: {success}',
      'この艦隊に属する全ての艦娘が対象です。': 'This applies to all ships belonging to this fleet.',
      '既に札がついている艦娘も上書きする': 'Overwrite all',
      '現在の登録情報に置き換え': 'Replaced by data of current registered ships and equipment',
      '存在しない艦娘、装備の置換方法を選択してください。': 'Please select a replacement mode for non-existent ship or equipment.',
      'この機能を使う場合は、まず艦隊反映を行ってください。': 'To use this function, please reflect the fleet data first.',
      '配備されているすべての艦娘と装備を、': 'Replace all deployed ships and equipment with the enrollment and possession information registered in ',
      'で登録されている在籍、所持情報をもとに、なるべくいい感じになるように置き換えます。': ' to make it as nice as possible.',
      'はずす': 'Remove',
      'そのままにする': 'Keep (Displayed in red if not in stock)',
      '必要': '{x} {name} are required.',
      '以下': 'No more than {x} {name}.',
      '編成不可': '{name} are prohibited.',
      '旗艦': '{name} as the flagship.',
      '旗艦不可': '{name} cannot be the flagship.',
      '高速化': '{name} needs to improve speed.',
      '装備置き場生成': 'Create Equipment Storage',
      '装備を自由に置くスペースです。': 'Free equipment storage',
      '一括編成': 'Bath Deploy',
      '選択済': 'Checked',
      '実装': 'Implement',
      '第1期': 'Phase 1',
      '第2期': 'Phase 2',
    },
    Enemies: {
      '海域': 'World',
      '海域名': 'Map Name',
      '敵艦隊': 'Enemies',
      '海域から一括入力': 'Batch input from map',
      '戦闘回数が変更されている可能性があります。派遣先を確認してください。': 'The number of battles may have changed. Please check the targeted nodes.',
      '戦闘回数': 'Number of battles',
      '航路': 'Nodes',
      'x戦目': 'Battle {number}',
      '搭載数が未確定の敵艦が含まれています。': 'Contains enemies with an undetermined number of slots.',
      '表示制空値は目安のもので、正確な制空値ではありません。': 'The indicated Fighter Power are for reference only and are not exact Fighter Power.',
      '海域選択': 'Node',
      '敵艦選択': 'Select Abyssal',
      'セル': 'Node',
      '戦闘形式': 'Type',
      '陣形': 'Form',
      '詳細': 'Details',
      '展開したい海域、セル、敵編成を選択してください。': 'Select the world, cell, and enemy you wish to deploy.',
      '選択したセル': 'Selected Nodes',
      '前哨': 'Normal',
      '最終': 'Final',
      'クリア後': 'After the win',
      '地上施設': 'Land Base',
      '変更する': 'Trade',
      'はずす': 'Remove',
      '詳細設定': 'Detail Setting',
      '基地航空隊フェーズで撃沈しない': 'Not calculate as if sunk in LBAS phase',
      '基地航空隊フェーズで撃沈する': 'Calculate as if sunk in LBAS phase',
      '耐久装甲表示': 'Show Armor',
      '本当に戦闘は1戦だけですか？意図せずこのエラーが出ている場合は、経由する道中の敵編成を全て入力してください。': 'There is only one battle? If you are getting this error unintentionally, please enter all the enemies you will go through along the way.',
    },
    Result: {
      '計算結果': 'Result',
      '計算結果が実際の制空状態と異なる可能性があります。': 'Calculated results may differ from actual results.',
      '戦闘開始時の搭載数推移': 'Number of slots at the beginning of the battle',
      '行クリックで詳細計算画面展開': 'Clicking on a row displays a detailed calculation dialog',
      '出撃x回分の計算結果が表示されています。': 'The calculation results for {number} sorties are displayed.',
      '再計算': 'Recalculate',
      '再計算して精度を上げる': 'Recalculate for accuracy',
      '出撃後': 'Result',
      '全滅率': 'Annihilation',
      '制空': 'Air State',
      '制空状態': 'Air State',
      '消費予測': 'Forecast',
      '各フェーズ制空状態の確率': 'Probability of Air State per phase',
      '基地x y波目': 'Base{number} Wave{wave}',
      '本隊': 'Fleet',
      '敵機残数': 'Remaining number of enemy slots',
      'このマスで選択する味方艦隊の陣形': 'Fleet formation to select for this Node',
      '敵艦': 'Abyssal',
      '初期搭載': 'Initial Slot',
      '残数平均': 'Average number of slots remaining',
      '棒立ち率': 'Incompetent',
      '詳細': 'Details',
      '支援艦隊': 'Support Expedition',
      '艦隊': 'Fleet',
      '種別': 'Support Type',
      '制空値は航空支援専用の制空値です。熟練度や改修値に影響されません。': 'FP is an FP dedicated to Airstrike Support. It is not affected by proficiency or improvement value.',
      '敵制空値は本隊航空戦終了時点での制空値の平均です。': 'EFP is the average of the Fighter Power at the end of Aerial Combat.',
      '詳細計算': 'Detailed calculation',
      '支援射撃': 'Shelling Support',
      '航空支援': 'Airstrike Support',
      '対潜支援哨戒': 'Anti-Submarine Support',
      '対潜支援制空': 'Asw Support FP',
      '支援長距離雷撃': 'Long Range Torpedo Support',
      '支援不可(要駆逐2)': 'None (2DD are required)',
      '支援不可(攻撃機なし)': 'Disabled (Attackers are required)',
      '不発': 'None',
      '合計触接率': 'Contact Rate',
      '対敵通常艦隊': 'Normal Battle',
      '対敵連合艦隊': 'Combined Battle',
      '触接開始率': 'Contact Trigger Rate',
      '触接率': ' Chance',
      'x12触接': 'x1.2 Contact',
      'x117触接': 'x1.17 Contact',
      'x112触接': 'x1.12 Contact',
      '触接不発': 'None',
      '攻撃機選択': 'Select Attacker',
      '搭載数': 'Slot',
      'クリティカル': 'Critical',
      '姫級表示': 'Show princess Class',
      '対潜火力(確率)': 'ASW Powers (Rate)',
      '航空支援火力': 'Airstrike Powers (Rate)',
      '倍率x': 'Multiplier x{number}',
      '対潜支援火力計算機で確認してください': 'Please show ASW Support Damage Tab',
      '雷装補正': 'Torpedo Multiplier',
      '種別倍率': 'Type Multiplier',
      'CI倍率': 'Cut-In Multiplier',
      '種別倍率(最小)': 'Type Multiplier (min)',
      '改修強化値': 'Improvement Bonus',
      '装備シナジーボーナス': 'Equipment Synergy Bonuses',
      '熟練甲板要員ボーナス': 'Skilled Deck Personnel Bonus',
      '実雷装値': 'Actual Torpedo',
      '実爆装値': 'Actual Bomber',
      '実対潜値': 'Actual Asw',
      '航空戦定数': 'Airstrike Modifiers',
      '基本攻撃力': 'Basic Attack Power',
      'キャップ前攻撃力': 'Pre-Cap Attack Power',
      'キャップ後攻撃力': 'Cap Adjusted Attack Power',
      'B-25補正': 'B-25 Modifiers',
      '基地航空隊補正': 'LBAS Modifiers',
      '触接補正': 'Contact Modifiers',
      '陸攻補正': 'LB Attacker Modifiers',
      '陸偵補正': 'LB Recon Modifiers',
      '敵連合補正': 'Enemy Combined Fleet Modifiers',
      '特殊敵補正': 'Specific Enemy Modifiers',
      '最終攻撃力': 'Final Fire Power',
      '最終攻撃力(最小)': 'Final Fire Power (min)',
      '弾薬補正値': 'Ammo Modifiers',
      'ダメージ幅': 'Damage Range',
      '撃沈率': 'Sunk',
      '大破率': 'Heavily Damaged',
      '中破率': 'Moderately Damaged',
      '確殺': 'certain kill',
      '残機数詳細': 'Plane Slots Detail',
      '火力計算': 'Airstrike Power Calculator',
      '残機数分布': 'Distribution of the number of remaining slot',
      '確率分布': 'Probability distribution (%)',
      '累積確率': 'Cumulative probability (%)',
      '残機数': 'Slot',
      '残機数分布をコピー': 'Copy Distribution Result',
      '航空戦火力計算機': 'Airstrike Power Calculator',
      '残機数分布を利用': 'Use Distribution',
      '対空砲火により撃墜される機数の確率分布を利用して計算します。': 'Calculations are performed using the results of probability distribution calculations.',
      '搭載数を固定してダメージを確認したい場合はチェックを外してください。': 'Uncheck the box if you want to fix the number of slots and check the damage.',
      '残弾薬': 'Remaining Ammo',
      '燃料補正': 'Remaining Fuel Modifier',
      '残弾薬補正': 'Remaining Ammo Modifier',
      '回避項x': 'Eva Term -{value}',
      '特効': 'Bonus',
      'キャップ後火力に適用される倍率です。': 'This is the multiplier applied to post-cap firepower.',
      'をクリックすると特効値をリセットします。': 'Click the left button to recalculate the value.',
      'クリティカル発生時のダメージを表示します。': 'Displays the damage caused by a critical hit.',
      'クリティカル補正': 'Critical Modifier',
      '熟練度クリティカル補正': 'Plane Proficiency Critical Modifier',
      '連合': 'Combined',
      '防御側が連合艦隊であるかどうかを設定します。': 'Sets whether the defender is a Combined Fleet.',
      'ダメージ計算結果': 'Result',
      '防御艦隊': 'Defender',
      'x戦目': '#{number}',
      '対潜攻撃不可': '-',
      '割合ダメージ': 'Chip',
      '-': '-',
      '二式陸偵': 'Type 2',
      '二式陸偵(熟練)': 'Type 2 (Skilled)',
      '素火力': 'Ship FP',
      '夜襲CI': 'Cut-In',
      '対空CI一覧': 'Check AA Cut-In',
      '種別id': 'id',
      '固定': 'fix',
      '変動': 'variable',
      '発動率': 'rate',
      '合計発動率': 'Total',
      '基地': 'LBAS',
    },
    EnemyEdit: {
      '敵艦編集': 'Edit Abyssal',
      '本機能は計算結果に大きな影響を及ぼすため、理解できる方のみ利用してください。': 'This function has a significant impact on calculation results and should only be used by those who understand it.',
      '指定した敵艦の装備や搭載数を自由に変更できます。': 'You can freely change the equipment and number of slots for a given Abyssal.',
      '設定内容はお使いのブラウザでのみ有効で、各種共有機能等による共有は行いません。': 'The modified information is only valid in your browser and cannot be shared via the Share function.',
      '編集する敵艦を選択': 'Select Abyssal',
      '変更済み敵艦一覧': 'List of Modified Abyssal',
      '装備、搭載数を設定してください。': 'Change the equipment and the number of slots.',
    },
    ItemList: {
      '図鑑id 名称検索': 'id',
      '敵装備': 'Abyssal Item',
      '対地攻撃': 'Attack Land Base',
      '夜間機': 'Night Aircraft',
      '射撃回避': 'Has Anti-Air Resistance',
      '特効装備': 'Special Bonus',
      '一列': 'Single',
      '複数列': 'Multi',
      '以上': 'or over',
      '以下': 'or less',
      '所持装備反映': 'Reflects registered equipment',
      '改修値無効': 'Sort by excluding improvement bonus',
      '装備シナジー無効': 'Sort by excluding synergy bonus',
      '熟練度成長': 'Growth speed',
      '戦': 'battles',
      '装備プリセット': 'Equipment Preset',
      '現在の装備構成で新規登録': 'Create',
      '現在の装備構成で上書き': 'Overwrite with current equipments',
      '名称': 'Title',
      '補強増設': 'Reinforcement Expansion',
      '固有プリセット': 'Unique Presets',
      'プリセット': 'Preset',
      '保存しました。': 'Completed.',
      '削除しました。': 'Completed.',
      '在庫がなくても展開': 'Force Expand',
      'x機': '{number}',
      'ブラックリスト': 'Blacklist',
      'ブラックリスト登録済み装備': 'Blacklisted equipment only',
      'ブラックリストに登録された装備は、装備一覧画面にて表示されなくなります。': 'Equipment on the blacklist will no longer be viewable from the equipment list.',
      '全解除': 'Remove all blacklisted equipment',
      '射程増加': 'Increasing "Range"',
      '改修値変更': 'Change Improvement',
      '装備名コピー': 'Copy item name',
      'wikiを開く': 'Open wiki',
      'メニューを閉じる': 'Close Menu',
      '装備比較': 'Compare',
      '装備シナジー確認': 'Show Synergy',
      '装備選択時は常に表示する': 'Show every time',
      '一括配備': 'Batch Deploy',
      '選択済': 'Checked',
      '補': 'Ex',
      'この装備を積んでいる艦': 'Ships equipped...',
    },
    Database: {
      '在籍艦娘 / 所持装備データ読込中': 'Now Loading',
      '反映': 'Import',
      '反映(改)': 'Import v2',
      '一覧': 'List',
      '札管理': 'Fleet Tag Manager',
      '比較': 'Compare',
      '経験値': 'Exp',
      '分析': 'Analytics',
      'ステータス上昇': 'Status Up',
      '基本条件': 'Basic Search Criteria',
      '名称検索': 'Name Search',
      '空白区切りで複数指定可': '(e.g.) 春雨 大鯨',
      'ネタバレ防止': 'Hide unowned ship graphics',
      '未着任艦非表示': 'Hide unowned ship',
      '未着任艦のみ': 'Only unowned ship',
      '補強増設開放済': 'Ex Slot open',
      '海色リボン': 'Sea-colored Ribbon',
      '白たすき': 'White Tasuki',
      'Lv上限': 'Max Lv',
      'Lv下限': 'Min Lv',
      '取込Lv下限': 'Import Min Lv',
      '運上限': 'Max Luck',
      '運下限': 'Min Luck',
      '対潜上限': 'Max Asw',
      '対潜下限': 'Min Asw',
      '索敵上限': 'Max LoS',
      '索敵下限': 'Min Asw',
      '回避上限': 'Max Eva',
      '回避下限': 'Min Eva',
      '命中項上限': 'Max Acc Term',
      '命中項下限': 'Min Acc Term',
      'CI項上限': 'Max Cut-In Term',
      'CI項下限': 'Min Cut-In Term',
      '耐久上限': 'Max HP',
      '耐久下限': 'Min HP',
      '耐久改修': 'HP Improvement',
      '耐久改修2': 'HP Imp.',
      '火力上限': 'Max Fire Power',
      '火力下限': 'Min Fire Power',
      '雷装上限': 'Max Torpedo',
      '雷装下限': 'Min Torpedo',
      '夜戦火力上限': 'Max Night Power',
      '夜戦火力下限': 'Min Night Power',
      '対潜改修': 'ASW Improvement',
      '対潜改修上限': 'Max ASW Improvement',
      '対潜改修下限': 'Min ASW Improvement',
      '運改修': 'Luck Improvement',
      '運改修上限': 'Max Luck Improvement',
      '運改修下限': 'Min Luck Improvement',
      '艦種': 'Ship Type',
      '国籍': 'Nationality',
      '日本': 'Japan',
      'アメリカ': 'The United States',
      'イタリア': 'Italy',
      'イギリス': 'England',
      'ドイツ': 'Germany',
      'フランス': 'France',
      'ソ連': 'Soviet',
      'その他': 'Others',
      'お札': 'Area Tag',
      '札なし': 'None',
      '一括チェック': 'Toggle All',
      '全選択': 'Select All',
      '一覧表示': 'Table Mode',
      '艦隊分析表示': 'Kantai Bunseki Mode',
      '在籍': 'Total',
      '新規登録': 'Register',
      '練度(Lv)': 'Lv',
      '着任': 'Construct',
      '除籍': 'Dismantle',
      '本当に除籍しますか？': 'Are you sure you want to dismantle it?',
      'やっぱやめとく': 'Cancel',
      '集計対象Lv': 'Analyzed by',
      '合計艦娘数': 'Total Ships',
      'ケッコン艦': 'Marriage Ships',
      '運改修合計': 'Total Luck Improvement',
      'まるゆ指数': 'Maruyu index',
      'まるゆを近代化改修に使えば使うほど上昇します。': 'This is an indicator that rises the more maruyu is consumed by modernization.',
      'ケッコン以外の手段で運改修を進めていると上昇する指標です。': 'This is an indicator that rises the more modernization of luck is implemented outside of marriage.',
      '耐久改修合計': 'Total HP Improvement',
      '対潜改修合計': 'Total ASW Improvement',
      '補強増設艦': 'Ship with additional slots',
      '改装設計図必要数': 'Number of Remodel Blueprints required',
      '戦闘詳報必要数': 'Number of Action Reports required',
      'カタパルト必要数': 'Number of Catapults required',
      '改装設計図消費数': 'Number of Remodel Blueprints consumed',
      '戦闘詳報消費数': 'Number of Action Reports consumed',
      'カタパルト消費数': 'Number of Catapults consumed',
      '改装設計図': 'Remodel Blueprint',
      '戦闘詳報': 'Action Report',
      'カタパルト': 'Catapults',
      '残exp': 'Required exp',
      '全て展開': 'Expand all',
      '全て折りたたむ': 'Collapse all',
      '隻数': 'Total',
      '最大Lv': 'Maximum Level',
      '最小Lv': 'Minimum Level',
      '中央Lv': 'Median Level',
      '平均Lv': 'Average Level',
      '総経験値': 'Total Exp',
      '1隻平均': 'Average of 1 ship',
      '経験値割合': 'Percentage of total Exp',
      '艦種別Lv帯分析': 'Distribution of Levels by ship type',
      'Lv帯別艦娘数': 'Number of ships per Level',
      '艦娘数': 'ships',
      '艦娘別経験値ランキング': 'Experience Ranking',
      '登録艦隊': 'Registered Data',
      '現在閲覧中の艦隊': 'Viewing Data',
      '差': 'Diff',
      'お札一括更新': 'Set Area Tag',
      'お札一斉解除': 'Clear all tags',
      '解除': 'Clear Tag',
      '札を解除します。よろしいですか？': 'Are you sure you want to clear the tag?',
      '解散': 'Reset',
      '解散します。よろしいですか？': 'Are you sure you want to reset?',
      '未所持装備非表示': 'Hide equipment not in stock',
      '改修下限': 'Min Star',
      '改修上限': 'Max Star',
      'カテゴリ': 'Category',
      '総所持数表示': 'Display the number of stock items.',
      '図鑑ID': 'No.',
      '所持数': 'Inventory',
      '破棄': 'Scrap',
      '全破棄': 'Scrap All',
      '計算したい項目': 'Status',
      '選択した項目と、次にその項目が1繰り上がるのは何Lvであるかを表示します。': 'The selected status and the Lv required for that status to increase are displayed.',
      '成長限界に到達した艦娘を省略': 'Omit ships with no further increase in status.',
      '任意': 'Free',
      '任意表示列': 'Manual Column',
      '必要経験値表示': 'Show Require EXP',
      '運改修モード': 'Luck Improvement Mode',
      'Lvはそのままに、運の改修によってステータスを上昇させようとした場合の結果を計算します。': 'Calculate the result of trying to increase status through luck improvement while keeping Lv the same.',
      '反映エリア': 'Paste Here',
      '共有URL発行機能': 'Generate Shared Link URL',
      '共有URL作成': 'Generate',
      'URL発行': 'Generate URL',
      '自分の艦隊、装備情報を他の人に見てもらうためのURLを発行します。': 'Generate a URL for others to view your fleet and equipment data.',
      '発行された情報は閲覧専用です。発行されたURLを他人に公開しても、自分の艦娘や装備情報が書き換えられてしまうことはありません。': "The URL generated is for viewing only. Even if you disclose the generated URL to others, your ship's daughter or equipment data will not be rewritten.",
      '閲覧する側は、共有された艦娘や装備情報を元に編成を作成することができます。': 'Viewers can create compositions based on the shared ship and equipment data.',
      'URL発行履歴': 'History of URL generation',
      '発行日': 'Generated date',
      '展開': 'View',
      '他サイト連携': 'Cooperation with Other Sites',
      '艦隊分析コード': 'Fleet Analysis Code',
      '艦隊分析コードが出力されています。この文字列を別の端末で反映することで、艦隊情報を復元することができます。': 'The kancolle-analysis code is output. By reflecting this string on another device, fleet information can be restored.',
      '艦隊コード': 'Ship',
      '装備コード': 'Equipment',
      '艦隊晒しページ(仮)で展開する場合はこちらから': 'Click here to expand on the 艦隊晒しページ(仮).',
      '反映手順を表示': 'Show steps to reflect',
      '反映手順を隠す': 'Hide steps to reflect',
      '手順1': 'After logging in, right-click on the game start screen and open the DevTools.',
      '手順2': 'Open the "Network" tab, and then press Game Start.',
      '手順3': 'When the port screen appears, "port" will be displayed, right click -> "Copy" -> "Copy Response".',
      '手順4': 'Paste it into the text area below and press "Import".',
      '手順5': 'Reflect your equipments. "require_info" will be displayed, right click -> "Copy" -> "Copy Response".',
      '下記はGoogle Chromeの場合です。': 'This is the case for Google Chrome.',
      '注意事項': 'Never double-click, "open in new tab," or "resubmit.',
      'ブラウザによって一部表記が変わります。': 'Some notations will change depending on the browser.',
      '未ロックの艦娘も含める': 'Include unlocked ship',
      'ロック済みの艦娘のみ': 'Exclude unlocked ship',
      '未ロックの装備も含める': 'Include unlocked equipment',
      'ロック済みの装備のみ': 'Exclude unlocked equipment',
      '札上書き注意': 'The area tag data for the fleet currently registered does not match the area tag data for the fleet to be imported.',
      'このまま取り込むと': 'If the fleet is imported as is, the currently registered area tag data may be overwritten.',
      '札データを上書きして取り込む': 'Overwrite area tag data and import',
      '札データを上書きせず取り込む': 'Import without overwriting area tag data',
      '成長の記録': 'Growth Record',
      '表示': 'Filter',
      '新規': 'New',
      '更新': 'Update',
      '経験値表示モード': 'Exp Mode',
      '着任しました。': 'Nice to meet you.',
      '除籍されました。': 'Bye.',
      'xから改造されました。': 'Modified from {base}.',
      '補強増設を使用しました。': 'Reinforcement expansion added.',
      '上限Lvに達しました。': 'Level has reached the maximum.',
      'ケッコンカッコカリしました。': 'Married.',
      'おめでとうございます！': 'Congratulations!',
      'Lvが上昇しました。': 'Lv. increased.',
      'xしました。': '{x}.',
      '増加経験値合計': 'Total Exp Increased ',
      '統計': 'Statistics',
      'さらに見る': 'See more',
      '在籍率': 'Registration rate',
      '総在籍数': 'Total number of registrations',
      '平均在籍数': 'Average number of ships owned',
      '最多在籍数': 'Maximum number of ships owned',
      '最多EXP': 'Maximum number of ship exp',
      'ケッコン率': 'Marriage rate',
      '補強増設開放率': '補強増設開放率',
      '補強増設開放数': '補強増設開放数',
      '海色リボン付与数': 'Number of times Sea-colored Ribbon was given',
      '白たすき付与数': 'Number of times White Tasuki was given',
      '総運改修値': 'Sum of all improvement luck',
      '総耐久改修値': 'Sum of all improvement HP',
      '総対潜改修値': 'Sum of all improvement ASW',
      'Lv平均': 'Average Lv',
      'Lv標準偏差': 'Standard score',
      'Lv偏差値計算': 'Calc Percentile',
      '艦娘偏差値': 'Percentile',
      '全体統計データ': 'Overall statistical data',
      'その他のデータ': 'Other data',
      'あなたのデータ': 'Your Data',
      '総経験値平均': 'Avg. Sum of all Exp',
      '総経験値中央値': 'Med. Sum of all Exp',
      '標準偏差': 'Standard score',
      '偏差値': 'Percentile',
      '自分のデータと比較': 'Compare',
      'コンバート艦': 'Popular converted ships',
      '所持率': 'percentage of items',
      '総在庫数': 'Total number of registrations',
      '平均所持数': 'Average number of items owned',
      '最多所持数': 'Maximum number of items owned',
      '集計の結果を閲覧する': 'Fetch Statistics Data',
      '自分のデータを送信する': 'Submit my data',
      'データ送信': 'Submit',
      'あなたの艦隊、装備データを統計データの集計対象として送信します。': 'When you click the submit button, your ship and equipment data will be sent to the server and will be included in the statistical data compilation.',
      '集計は一日一回実行されます。データを送信した後すぐに反映はされませんのでご注意ください。': 'Aggregation is performed once a day. Please note that the data will not be reflected immediately after it is submitted.',
      '送信しました': 'Completed.',
      '集計データが取得できませんでした。': 'Statics data could not be retrieved.',
      '一度、サイトの再読み込みをしてみてください。それでも取得できない場合は集計中かも。': 'Please try reloading the site once. If you still cannot retrieve the data, please try again later, as the data may be in the process of being compiled.',
      'Lv中央値': 'Median Level',
      'サーバー平均': 'Average',
      'サーバー中央値': 'Median',
    },
    Extra: {
      '艦娘性能一覧': 'Ships',
      '艦娘の基本ステータスの確認と比較を行えます。': 'You can check and compare the basic status of each ship.',
      '差分表示': 'Diff',
      '装備性能一覧': 'Equipments',
      '装備の基本ステータスの確認と比較を行えます。': 'You can check and compare the basic status of each equipment.',
      '搭載可能な装備で絞り込み': 'Only Equipable',
      '対空射撃回避機体一覧': 'List of plane has Anti-Air Resistance',
      '対潜値計算機': 'ASW Calculator',
      '艦娘と装備から、指定した対潜値と必要なLvを計算します。': 'Calculate the specified asw value and required Lv from the ship and equipment.',
      '素対潜': 'Base Asw',
      '表示対潜': 'Display Asw',
      '初期対潜': 'Min Asw',
      '最大対潜': 'Max Asw',
      '装備対潜合計': 'Total Equipment Asw',
      '装備ボーナス合計': 'Total Equipment Bonus',
      '目標対潜値': 'Target Asw Value',
      '必要Exp': 'Required Ship exp',
      '到達不可': 'Unreachable',
      '参考': 'Reference',
      '先制対潜発動条件について': 'About Opening Asw',
      '敵艦生息地検索': 'Abyssal Habitat Searcher',
      '指定した敵艦が登場する海域を検索します。データが更新されていない場合もあるので、あくまで参考程度に。': 'Search for sea areas where the specified Abyssal appears. It may not be that correct, so just for fun.',
      '検索する敵艦を選択': 'Select Abyssal',
      '艦隊詳細': 'Fleet Details',
      '戦果砲管理': 'Ranking Point Quest Manager',
      '戦果に関係する任務の進捗を管理する機能です。': 'Manage the progress of quests that reward ranking points.',
      '未達成': 'In progress',
      '達成済': 'Completed',
      '達成': 'Complete',
      '未達成にする': 'Reset',
      'あと': 'Time Remaining',
      'x日': '{days} days',
      '1日': '1 day',
      '失効': 'Time-out',
      '達成日': 'Completed Date',
      'S勝利': 'Rank S',
      'A勝利': 'Rank A',
      '戦果砲残弾合計': 'Total Remaining Ranking Points',
      'クォータリー': 'Quarterly',
      'イヤーリー': 'Yearly',
      '単発': 'One-Time',
      'マンスリー': 'Monthly',
      'ウィークリー': 'Weekly',
      '全て': 'All',
      'wikiで開く': 'Open wiki',
      '改装特務空母「Gambier Bay Mk II」抜錨！': 'Remodeled Utility Carrier "Gambier Bay Mk.II" Weigh Anchor!',
      '戦果拡張任務！「Z作戦」前段作戦': 'Military Gains Extra Operation: "Operation Z", First Part',
      '新編成「三川艦隊」、鉄底海峡に突入せよ！': 'New Mikawa Fleet, rush into the Iron Bottom Sound!',
      '泊地周辺海域の安全確保を徹底せよ！': 'Thoroughly Secure the Sea Around the Anchorages!',
      '戦果拡張任務！「Z作戦」後段作戦': 'Military Gains Extra Operation: "Operation Z" Latter Operation',
      '南西諸島方面「海上警備行動」発令！': '"Surface Security Actions" around the Nansei Archipelago Announcement',
      '発令！「西方海域作戦」': 'Announcement! "Western Waters Operation"',
      '拡張「六水戦」、最前線へ！': 'Expanded 6th Torpedo Squadron, to the Front Lines!',
      'AL作戦': 'Operation AL',
      '機動部隊決戦': 'Naval Task Force Decisive Battle',
      'この任務を達成状態にしますか？': 'Are you sure you want to complete this quest?',
      '達成した任務は、達成済タブに表示されるようになります。': 'Completed quests will appear in the "COMPLETED" tab.',
      '達成しました。': 'Completed.',
      '全ての任務進捗をリセットします。よろしいですか？': 'Are you sure you want to reset all quest?',
      'リセットしました。': 'Reset',
      '敵対空おばけ': 'Abyssal AA Ranking',
      '敵艦の対空砲火ランキングです。見かけたら気を付けるか覚悟しましょう。': 'Ranking of Abyssal Anti-Air performance.',
      '順位': 'Rank',
      '機': 'slots',
      '備考': 'Remarks',
      '対空CI発動可能': 'Anti-Air Cut-In can be triggered',
      '装備シナジーチェッカー': 'Equipment Synergy Bonuses Checker (prototype)',
      '条件': 'COND.',
      '累積可': 'Multiple',
      '累積不可': 'One-Time',
      '水上電探': 'Surface Radar',
      '対空電探': 'Air Radar',
      '命中電探': 'Accuracy (+8) Radar',
    },
    EType: {
      '小口径主砲': 'Small Cal. Main Gun',
      '中口径主砲': 'Medium Cal. Main Gun',
      '大口径主砲': 'Large Cal. Main Gun',
      '副砲': 'Secondary Gun',
      '魚雷': 'Torpedo',
      '艦上戦闘機': 'Fighter Aircraft',
      '艦上爆撃機': 'Dive Bomber',
      '艦上攻撃機': 'Torpedo Bomber',
      '艦上偵察機': 'Recon Aircraft',
      '水上偵察機': 'Recon Seaplane',
      '水上爆撃機': 'Seaplane Bomber',
      '小型電探': 'Small Radar',
      '大型電探': 'Large Radar',
      'ソナー': 'Sonar',
      '爆雷': 'Depth Charge',
      '爆雷投射機': 'Depth Charge Launcher',
      '追加装甲': 'Extra Armor',
      '機関部強化': 'Engine',
      '対空強化弾': 'AA Shell',
      '対艦強化弾': 'AP Shell',
      'VT信管': 'VT Fuze',
      '対空機銃': 'AA Machine Gun',
      '特殊潜航艇': 'Midget Submarine',
      '応急修理要員': 'Emergency Repair',
      '上陸用舟艇': 'Landing Craft',
      '回転翼機': 'Rotorcraft',
      '対潜哨戒機': 'Anti-Sub PBY',
      '追加装甲(中型)': 'Armor (Medium)',
      '追加装甲(大型)': 'Armor (Large)',
      '探照灯': 'Searchlight',
      '簡易輸送部材': 'Supply Container',
      '艦艇修理施設': 'Ship Repair Facility',
      '潜水艦魚雷': 'Submarine Torpedo',
      '照明弾': 'Star Shell',
      '司令部施設': 'Command Facility',
      '航空要員': 'Aviation Personnel',
      '高射装置': 'AA Fire Director',
      '対地装備': 'Anti-Ground',
      '大口径主砲(II)': 'Large Cal. Main Gun (2)',
      '水上艦要員': 'Ship Personnel',
      '大型ソナー': 'Large Sonar',
      '大型飛行艇': 'Large Flying Boat',
      '大型探照灯': 'Large Searchlight',
      '戦闘糧食': 'Combat Ration',
      '補給物資': 'Supplies',
      '水上戦闘機': 'Seaplane Fighter',
      '特型内火艇': 'Amphibious Tank',
      '陸上攻撃機': 'LB Attack Aircraft',
      '局地/陸軍戦闘機': 'Interceptor/LB Fighter',
      '陸上偵察機': 'LB Recon Aircraft',
      '輸送機材': 'Transport Device',
      '潜水艦装備': 'Submarine Equipment',
      '大型陸上機': 'Large LB Aircraft',
      '噴式戦闘機': 'Jet Fighter',
      '噴式戦闘爆撃機': 'Jet Fighter-Bomber',
      '噴式攻撃機': 'Jet Torpedo Bomber',
      '噴式偵察機': 'Jet Recon Aircraft',
      '大型電探(II)': 'Large Radar (2)',
      '艦上偵察機(II)': 'Recon Aircraft (2)',
      '副砲(II)': 'Secondary (2)',
      '艦戦': 'Fighter Aircraft',
      '艦爆': 'Dive Bomber',
      '艦攻': 'Torpedo Bomber',
      '艦偵': 'Recon Aircraft',
      '噴式機': 'Jet Fighter-Bomber',
      '水偵': 'Recon Seaplane',
      '水爆': 'Seaplane Bomber',
      '水戦': 'Seaplane Fighter',
      '電探': 'Radar',
      '対潜装備': 'ASW Weapon',
      '機銃': 'AA Machine Gun',
      '陸攻': 'LB Attack Aircraft',
      '局戦': 'Interceptor/LB Fighter',
      '陸偵': 'LB Recon Aircraft',
      '陸戦部隊': 'Tank',
      '艦載発煙装置': 'Smoke',
      'その他': 'Others',
    },
    SType: {
      '海防': 'DE',
      '駆逐': 'DD',
      '軽巡': 'CL',
      '雷巡': 'CLT',
      '重巡': 'CA',
      '航巡': 'CAV',
      '軽母': 'CVL',
      '高戦': 'FBB',
      '戦巡': 'FBB',
      '戦艦': 'BB',
      '航戦': 'BBV',
      '空母': 'CV',
      '超戦': 'XBB',
      '潜水': 'SS',
      '航潜': 'SSV',
      '輸送': 'AP',
      '水母': 'AV',
      '揚陸': 'LHA',
      '装母': 'CVB',
      '装空': 'CVB',
      '工作': 'AR',
      '潜母': 'AS',
      '練巡': 'CT',
      '補給': 'AO',
      '護母': 'CVE',
      'その他': 'Aux',
      '正規空母': 'CV',
      '軽空母': 'CVL',
      '戦艦級': 'BB Class',
      '重巡級': 'CA Class',
      '軽巡級': 'CL Class',
      '駆逐艦': 'DD',
      '海防艦': 'DE',
      '潜水艦': 'SS',
      '補助艦艇': 'Aux',
      '合計': 'Total',
      '高速戦艦': 'FBB',
      '航空戦艦': 'BBV',
      '潜水空母': 'SSV',
      '揚陸艦': 'LHA',
      '装甲空母': 'CVB',
      '工作艦': 'AR',
      '潜水母艦': 'AS',
      '巡洋艦系': 'CL/CLT/CA/CAV/FBB/BB/BBV',
      '軽空母と空母': 'CV/CVL',
      '護衛空母': 'Escort Carrier',
      '駆逐艦または海防艦': 'DD/DE',
      '軽巡または練巡': 'CL/CT',
    },
    '改': ' Kai',
    '甲': ' A',
    '乙': ' B',
    '丙': ' C',
    '丁': ' D',
    '戊': ' E',
    '特': ' Toku',
    '護': ' Go',
    '重': ' Juu',
    '母': ' Bo',
    '戦': ' Sen',
    '航': ' -Kou',
    '改二': ' Kai Ni',
    '改三': ' Kai San',
    '3': ' III',
    ' zwei': ' Zwei',
    ' drei': ' Drei',
    ' due': ' Due',
    ' andra': ' Andra',
    ' nuovo': ' Nuovo',
    ' два': ' Dva',
    ' Mod 2': ' Mod.2',
    ' Mk II': ' Mk.II',
    'elite': ' Elite',
    'flagship': ' Flagship',
    '改flagship': ' Kai Flagship',
    'II': ' II',
    'IIelite': ' II elite',
    'IIflagship': ' II Flagship',
    '後期型': ' Late Model',
    '後期型elite': ' Late Model Elite',
    '後期型flagship': ' Late Model Flagship',
    '後期型II': ' Late Model II',
    '後期型IIelite': ' Late Model II Elite',
    '後期型IIflagship': ' Late Model II Flagship',
    'IIe(量産型)': ' IIe (Mass Production Model)',
    'IIe(量産型)elite': ' IIe (Mass Production Model) Elite',
    'IIe(量産型)flagship': ' IIe (Mass Production Model) Flagship',
    '-壊': ' (Damaged)',
    '[甲]': ' (Hard)',
    '[乙]': ' (Medium)',
    '[丙]': ' (Easy)',
    '[丁]': ' (Casual)',
    '[乙/丙]': ' (Easy)',
    'vac.': ' vac.',
    '夏mode': ' Summer Mode',
    ' II夏季上陸': ' II Summer Landing Mode',
    '(哨戒機配備)': ' (w/ Patrol Aircraft)',
    '級': ' Class',
    '型': ' Class',
  },
};
